<section>
    <xm-modal-close xmEscKey (escKeyPressed)="close()" (onClose)="close()"></xm-modal-close>
    <h2 class="header">{{ data.header }}</h2>
    <div class="description" *ngFor="let content of data.content">
        <cms-text [originalText]="content"></cms-text>
    </div>
</section>
